import React from 'react';
import ChartSettings from './chart/ChartSettings.jsx';
import DatasetSettings from './dataset/DatasetSettings.jsx';

function ChartDatasetSettings({
    chart_settings_props = {},
    dataset_settings_props = {},
    DatasetSettingsComponent = DatasetSettings,
    ChartSettingsComponent = ChartSettings,
    widgetId
}) {
    return (
        <div>
            <ChartSettingsComponent {...chart_settings_props} widgetId={widgetId} />
            {DatasetSettingsComponent && <><hr /><DatasetSettingsComponent {...dataset_settings_props} widgetId={widgetId} /></>}
        </div>
    )
}

export default ChartDatasetSettings;
